import './App.css';

import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { Profile, Homepage, Impressum, Datenschutz, ContactFormula, MyEvents, EventsStore, MyEventDetails, ResetPassword, EventsAdmin, Bookedeventsdetails, BookedPubCrawlDetails, VerifyEmail, PaymentReturn } from './components';
import { useTranslation } from 'react-i18next';


function App() {
  const { t } = useTranslation();

  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Homepage />}></Route>
        <Route path="/profile" element={<Profile />}></Route>
        <Route path="/impressum" element={<Impressum />}></Route>
        <Route path="/datenschutz" element={<Datenschutz />}></Route>
        <Route path="/kontakt" element={<ContactFormula />}></Route>
        <Route path="/profile/myevents" element={<MyEvents />}></Route>
        <Route path="/eventsstore" element={<EventsStore />}></Route>
        <Route path="/reset-password/:token" element={<ResetPassword />}></Route>
        <Route path="/verify-email/:token" element={<VerifyEmail />}></Route>
        <Route path="/profile/eventsadmin" element={<EventsAdmin />}></Route>
        <Route path="/profile/bookedevents" element={<Bookedeventsdetails />}></Route>
        <Route path="/profile/pubcrawl" element={<BookedPubCrawlDetails />}></Route>
        <Route path="/payment-return" element={<PaymentReturn />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;